<template>
  <div class="loginPage col-12 px-0">
    <!-- ============ LOGIN CARD ============ -->
    <div id="loginShow" v-if="present == 'login' && localParentPresent == 'login'" class="login-card">

      <!-- Brand -->
      <div class="login-brand">
        <img src="../assets/images/newLogo1.png" alt="PTEClasses" class="login-logo" />
        <h2 class="login-title">Welcome Back</h2>
        <p class="login-subtitle">Login to continue your PTE practice journey</p>
      </div>

      <p v-if="showBrowserAlert" class="browser-alert">
        Please use the newest version of <strong>Google Chrome / Firefox</strong> to use all features.
      </p>

      <!-- Social logins -->
      <div class="social-stack">
        <vue-apple-login
          mode="center-align"
          type="sign in"
          color="black"
          :border="true"
          :radius="8"
          width="100%"
          height="48px"
          logoSize="medium"
          max-width="500px"
          :logoPosition="0"
          :labelPosition="0"
          className="vue-apple-login"
          :onSuccess="onAppleSuccess"
          :onFailure="onAppleFailure"
        ></vue-apple-login>

        <GoogleLogin :params="params" :onSuccess="onSuccess" class="social-btn google-btn">
          <img src="../assets/images/google.png" class="social-icon" alt="" />
          <span>Sign in with Google</span>
        </GoogleLogin>
      </div>

      <!-- OR divider -->
      <div class="or-divider"><span>OR</span></div>

      <!-- Error -->
      <div v-if="error != null" class="login-error" role="alert">{{ error }}</div>

      <!-- Email / password form -->
      <form class="login-form" novalidate
            @submit.prevent="validData && loginBtnText == 'Login' && submit()">
        <div class="field">
          <label for="login-email">Email or Username</label>
          <div class="input-wrap">
            <svg class="input-icon" viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <path d="M3.5 6.5l8.5 6.5 8.5-6.5" />
            </svg>
            <input id="login-email" type="text" v-model="form.email_id" name="email"
                   placeholder="Enter your email or username" autocomplete="username" />
          </div>
        </div>

        <div class="field">
          <label for="login-password">Password</label>
          <div class="input-wrap">
            <svg class="input-icon" viewBox="0 0 24 24" aria-hidden="true">
              <rect x="5" y="11" width="14" height="10" rx="2" />
              <path d="M8 11V7a4 4 0 0 1 8 0v4" />
            </svg>
            <input id="login-password" :type="showPassword ? 'text' : 'password'" v-model="form.password"
                   name="password" placeholder="Enter your password" autocomplete="current-password" />
            <button type="button" class="toggle-eye" @click="showPassword = !showPassword"
                    :aria-label="showPassword ? 'Hide password' : 'Show password'">
              <svg v-if="!showPassword" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
              <svg v-else viewBox="0 0 24 24" aria-hidden="true">
                <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
                <circle cx="12" cy="12" r="3" />
                <path d="M4 4l16 16" />
              </svg>
            </button>
          </div>
          <div class="forgot-row">
            <a href="#" class="link-sm" @click.prevent="present = 'forgetPassword'">Forgot your password?</a>
          </div>
        </div>

        <button type="submit" class="login-btn" :disabled="!validData || loginBtnText != 'Login'">
          <span>{{ loginBtnText }}</span>
          <svg v-if="loginBtnText == 'Login'" class="btn-arrow" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </button>
      </form>

      <p class="signup-line">
        Don't have an account?
        <a href="#" @click.prevent="present = 'register'">Create an account</a>
      </p>

      
    </div>

    <!-- ============ OTHER VIEWS (unchanged for now) ============ -->
    <app-Register v-if="present == 'register' && localParentPresent == 'login'" />
    <app-ForgotPassword v-if="present == 'forgetPassword' && localParentPresent == 'login'" />
    <app-ResetPassword v-if="present == 'login' && localParentPresent == 'resetPassword'" />
<!-- <div class="brand-tagline">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path class="fill" d="M12 4L1 9l11 5 9-4.1V16h2V9z" />
            <path d="M5.5 11.5V16c0 1.7 2.9 3 6.5 3s6.5-1.3 6.5-3v-4.5" />
          </svg>
          <span>Better English<br />Brighter Opportunities</span>
        </div> -->
    <!-- <app-googleAds :id="'loginPageAd'" :key="$route.fullPath"
                   v-if="present == 'login' && localParentPresent == 'login'" :adSlot="'2513466703'"></app-googleAds> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GoogleLogin from 'vue-google-login';
import facebookLogin from 'facebook-login-vuejs';
import ForgotPassword from '@/components/ForgotPassword.vue'
import Register from '../components/Register.vue'
import ResetPassword from '../components/ResetPassword'
import googleAds from './reuseable/googleAds.vue';

export default {
    props: {
        parentPresent: {
            default: 'login',
            required: false
        }
    },
    components: {
        GoogleLogin,
        facebookLogin,
        'app-Register': Register,
        'app-ForgotPassword': ForgotPassword,
        'app-ResetPassword': ResetPassword,
        'app-googleAds': googleAds
    },
    data () {
        return {
            from: '/',
            present: 'login',
            loginBtnText: 'Login',
            localParentPresent: this.parentPresent,
            showBrowserAlert: false,
            showPassword: false, // NEW: eye toggle on password field
            signedIn: false,
            form: {
                email_id: '',
                password: '',
            },
            isInit: false,
            isSignIn: false,
            error: null,
            params: {
                client_id: "662951235152-ua8fih2usk2g9h2bfh81i8d2dvstt0vl.apps.googleusercontent.com"
            },
            renderParams: {
                width: 250,
                height: 40,
                longtitle: true
            },
            userAnswer: {
                first_name: '',
                last_name: '',
                email_id: '',
                url: ''
            },
            fb: {
                cu: '',
                fV: '',
                isConnected: false
            }
        }
    },
    methods: {
        ...mapActions({
            signIn: 'auth/login',
            loginSocialMedia: 'auth/loginSocialMedia'
        }),
        ...mapGetters({
            getError: 'auth/getError',
            authDetail: 'auth/authenticated'
        }),

        callingRecheckUser() {
            this.$parent.$parent.recheckUser()
        },
        onAppleSuccess(data) {
            console.log(data);
            var vm = this
            this.signedIn = true;
            const tempData = data.userData;
            var user = {
                first_name: tempData.givenName,
                email_id: tempData.email,
                last_name: tempData.familyName,
                active_ind: 'T',
                apple_user_id: tempData.sub
            };
            if (user.first_name == null && user.apple_user_id == null) {
                return this.$alert("Login Failed.", "Failed", "error", { confirmButtonText: "Try Again!" });
            }
            this.loginSocialMedia(user).then(() => {
                const details = this.authDetail()
                console.log(details)
                this.$ls.set('tokenVal', details.token)
                this.$ls.set('uniqueKey', details.uniqueKey)
                this.$ls.set('user', details.user)
                this.$ls.set('currentQuestion', 'dashboard')
                vm.$browserStore.setLocal('tokenVal', details.token)
                vm.$browserStore.setLocal('uniqueKey', details.uniqueKey)
                vm.$browserStore.setLocal('backUser', JSON.stringify(details.user))
                vm.$ls.set('currentQuestion', 'dashboard')
                this.$parent.$parent.recheckUser()
            });
        },
        onAppleSuccessLogout() {
            this.signedIn = false;
        },
        onAppleFailure(error) {
            console.log(error);
            return this.$alert("Login Failed.", "Failed", "error", { confirmButtonText: "Try Again!" });
        },
        submit() {
            this.loginBtnText = 'Processing....'
            this.$browserStore.clearLocal()
            var vm = this
            this.signIn(this.form).then(function () {
                if (vm.getError() == '') {
                    vm.$browserStore.setLocal('tokenVal', vm.$ls.get('tokenVal'))
                    vm.$browserStore.setLocal('backUser', JSON.stringify(vm.$ls.get('user')))
                    vm.$ls.set('currentQuestion', 'dashboard');
                    vm.$parent.$parent.recheckUser();
                    vm.loginBtnText = 'Login'
                }
                else {
                    vm.error = vm.getError()
                    vm.loginBtnText = 'Login'
                }
            })
        },
        onSuccess(googleUser) {
            const tempData = googleUser.getBasicProfile();
            var vm = this
            var user = {
                first_name: tempData.getGivenName(),
                email_id: tempData.getEmail(),
                last_name: tempData.getFamilyName(),
                active_ind: 'T'
            };
            if (user.first_name == null) {
                return this.$alert("Login Failed.", "Failed", "error", { confirmButtonText: "Try Again!" });
            }
            this.loginSocialMedia(user).then(() => {
                const details = this.authDetail()
                console.log(details)
                this.$ls.set('tokenVal', details.token)
                this.$ls.set('uniqueKey', details.uniqueKey)
                this.$ls.set('user', details.user)
                this.$ls.set('currentQuestion', 'dashboard')
                vm.$browserStore.setLocal('tokenVal', details.token)
                vm.$browserStore.setLocal('uniqueKey', details.uniqueKey)
                vm.$browserStore.setLocal('backUser', JSON.stringify(details.user))
                vm.$ls.set('currentQuestion', 'dashboard')
                this.$parent.$parent.recheckUser()
            });
        },
        getUserData() {
            var vm = this;
            window.FB.api('/me', 'GET', { fields: 'name,email' },
                userInformation => {
                    this.fb.cu = userInformation.email;
                    this.fb.fV = userInformation.name;
                    if (this.fb.cu != null) {
                        var user = {
                            first_name: this.fb.fV,
                            email_id: this.fb.cu,
                            active_ind: 'T'
                        };
                        this.loginSocialMedia(user).then(() => {
                            vm.$browserStore.setLocal('tokenVal', vm.$ls.get('tokenVal'))
                            vm.$browserStore.setLocal('uniqueKey', vm.$ls.get('uniqueKey'))
                            vm.$browserStore.setLocal('backUser', JSON.stringify(vm.$ls.get('user')))
                            this.$ls.set('currentQuestion', 'dashboard')
                            this.$parent.$parent.recheckUser()
                        });
                    }
                }
            )
        },
        sdkLoaded(payload) {
            this.fb.isConnected = payload.isConnected;
            this.fb.FB = payload.FB
            if (this.isConnected) this.getUserData();
        },
        onLogin() {
            this.fb.isConnected = true;
            this.getUserData();
        },
        onLogout() {
            this.isConnected = false;
        }
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.error = null
            }
        },
    },
    computed: {
        validData: function () {
            return this.error == null && this.form.email_id != '' && this.form.password != '';
        }
    },
    mounted() {
        if (this.$ls.get('referral') != null) {
            this.present = 'register'
        }
        if (this.$ls.get('userSettings') != null) {
            if (this.$ls.get('userSettings') == 'removeAccount')
                return this.$alert("To remove your account permanently you need to login first & delete it from Settings.")
        }
    },
    created() {
        this.loginBtnText = 'Login';
        if (this.$browserDetect.isSafari) {
            this.showBrowserAlert = true
        }
    },
}
</script>

<!-- ================= NEW DESIGN (scoped) ================= -->
<style scoped>
.login-card {
    --pc-primary: #0058f2;
    --pc-primary-dark: #0058f2;
    --pc-navy: #011658;
    --pc-text: #011658;
    --pc-muted: #5b6475;
    --pc-border: #dde3ee;
    --pc-soft: #f5f8fd;

    max-width: 450px;
    margin: 0 auto;
    padding: 5px 40px 30px;
    background: #fff;
    border-radius: 22px;
    box-shadow: 0 12px 40px rgba(20, 60, 140, 0.10);
    font-family: 'Poppins', 'Segoe UI', system-ui, sans-serif;
    color: var(--pc-text);
}

/* Brand */
.login-brand { text-align: center; margin-bottom: 20px; }
.login-logo { height: 70px; max-width: 100%; margin-bottom: 25px; }
.login-title { 
    font-size: 25px;
    font-weight: 700;
    color: var(--pc-navy) !important;
    margin: 0 0 6px;
    letter-spacing: -0.3px;
    text-transform: capitalize;
 }
.login-subtitle { font-size: 15px; color: var(--pc-muted); margin: 0; }

.browser-alert {
    background: #eef4ff; color: #1e467f; border-radius: 10px;
    padding: 10px 14px; font-size: 13px; margin-bottom: 16px; text-align: center;
}
.browser-alert strong { color: #16a34a; }

/* Social */
.social-stack { display: flex; flex-direction: column; gap: 12px; }
.social-stack ::v-deep .vue-apple-login { width: 100%; cursor: pointer; }
.vue-apple-login > div[style]{
    max-width: 100%!important;
}
.social-btn {
    display: flex; align-items: center; justify-content: center; gap: 10px;
    width: 100%; height: 48px; border-radius: 8px;
    background: #fff; border: 1px solid var(--pc-border);
    font-size: 16px; font-weight: 500; color: var(--pc-text);
    cursor: pointer; transition: box-shadow .2s, border-color .2s;
}
.social-btn:hover { border-color: #c5cfe0; box-shadow: 0 2px 10px rgba(0,0,0,0.06); }
.social-icon { width: 22px; height: 22px; }

/* OR divider */
.or-divider {
    display: flex; align-items: center; gap: 14px;
    margin: 12px 0 12px; color: var(--pc-muted); font-size: 12px;
}
.or-divider::before, .or-divider::after { content: ''; flex: 1; height: 1px; background: var(--pc-border); }

/* Error */
.login-error {
    background: #fdecec; color: #b42318; border: 1px solid #f7caca;
    border-radius: 8px; padding: 10px 14px; font-size: 14px; font-weight: 600; margin-bottom: 14px;
}

/* Fields */
.field { margin-bottom: 18px; text-align: left; }
.field label { display: block; font-size: 14px; font-weight: 600; color: var(--pc-text); margin-bottom: 8px; }
.input-wrap { position: relative; display: flex; align-items: center; }
.input-wrap input {
    width: 100%; height: 50px; padding: 0 46px 0 50px;
    border: 1px solid var(--pc-border); border-radius: 8px;
    font-size: 15px; color: var(--pc-text); background: #fff;
    transition: border-color .2s, box-shadow .2s;
}
.input-wrap input::placeholder { color: #8a93a5; }
.input-wrap input:focus { outline: none; border-color: var(--pc-primary); box-shadow: 0 0 0 3px rgba(20,99,243,0.12); }
.input-icon, .toggle-eye svg {
    width: 20px; height: 20px; fill: none; stroke: #4b5563;
    stroke-width: 1.7; stroke-linecap: round; stroke-linejoin: round;
}
.input-icon { position: absolute; left: 18px; pointer-events: none; }
.toggle-eye {
    position: absolute; right: 12px; background: none; border: 0; padding: 4px;
    display: flex; cursor: pointer;
}
.forgot-row { text-align: right; margin-top: 10px; }
.link-sm { font-size: 13px; font-weight: 500; color: var(--pc-primary); text-decoration: none; }
.link-sm:hover { text-decoration: underline; }

/* Login button */
.login-btn {
    position: relative; width: 100%; height: 40px; margin-top: 5px;
    display: flex; align-items: center; justify-content: center;
    border: 0; border-radius: 8px; background: var(--pc-primary); color: #fff!important;
    font-size: 18px; font-weight: 600; cursor: pointer; transition: background .2s;
}
.login-btn:hover:not(:disabled) { background: var(--pc-primary-dark); }
.login-btn:disabled { opacity: .6; cursor: not-allowed; }
.btn-arrow {
    position: absolute; right: 22px; width: 22px; height: 22px;
    fill: none; stroke: #fff; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round;
}

.signup-line { text-align: center; font-size: 14px; color: var(--pc-text); margin: 16px 0 22px; }
.signup-line a { color: var(--pc-primary); font-weight: 600; text-decoration: none; }
.signup-line a:hover { text-decoration: underline; }

/* Discover more */
.discover { background: var(--pc-soft); border-radius: 12px; padding: 14px 14px 6px; }
.discover-title { font-size: 17px; font-weight: 700; color: var(--pc-text); margin: 0 0 8px 2px; }
.discover-item {
    display: flex; align-items: center; gap: 14px;
    padding: 12px 8px; background: #fff; text-decoration: none; color: var(--pc-text);
    border-bottom: 1px solid #edf0f6;
}
.discover-item:first-of-type { border-radius: 8px 8px 0 0; }
.discover-item:last-of-type { border-bottom: 0; border-radius: 0 0 8px 8px; margin-bottom: 8px; }
.discover-item:hover { background: #fafcff; }
.discover-icon { width: 28px; display: flex; justify-content: center; }
.discover-icon svg { width: 22px; height: 22px; stroke-width: 1.8; stroke-linejoin: round; stroke-linecap: round; }
.ic-blue svg   { fill: #3b82f6; stroke: #1d4ed8; }
.ic-green svg  { fill: #22c55e; stroke: #fff; }
.ic-orange svg { fill: #fdba74; stroke: #ea580c; }
.discover-label { flex: 1; font-size: 15px; font-weight: 500; }
.chevron { width: 18px; height: 18px; fill: none; stroke: #374151; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }

@media (max-width: 575px) {
    .login-card { padding: 28px 18px 20px; border-radius: 16px; }
    .login-title { font-size: 28px; }
}
</style>

<!-- ============ LEGACY GLOBAL STYLES ============
     Kept unscoped so Register / ForgotPassword / ResetPassword
     keep looking the same until we redesign them in later steps. -->
<style>
.loginBtn, .fb-signin-button button {
    width: 100% !important; margin: auto !important; height: 41px !important;
    border-radius: 5px !important; color: #fff !important; min-width: auto !important;
}
.loginBtn { min-width: 120px !important; width: fit-content !important; padding: 6px 20px !important; }
.fb-signin-button { border-radius: 3px; color: #fff; padding: 0px !important; }
.spinner { display: none !important; }
label { font-weight: 600; }
.abcRioButtonLightBlue.abcRioButton { height: 40px !important; width: 100% !important; border-radius: 5px !important; }
.abcRioButtonIcon { padding-top: 12px !important; }
.abcRioButtonContents { line-height: 40px !important; margin-left: 0px !important; margin-right: 20px !important; }
.ml-xl-5.loginBg { min-width: 590px !important; }
.googleIcon { width: 25px; left: 10px; position: absolute; }
.btn.gmailBtn {
    background: #fff; padding: 8px 0px; width: 100%;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px !important; color: #757575 !important;
}
</style>